// extracted by mini-css-extract-plugin
export default {"fallback":"FallbackUI_fallback__Ua4Pu","rotator":"FallbackUI_rotator__+seF4"};